import { render, staticRenderFns } from "./steps.vue?vue&type=template&id=72d99b9a&"
import script from "./steps.vue?vue&type=script&lang=js&"
export * from "./steps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports